class MakerIsProductMediaFallback extends HTMLElement {
  connectedCallback() {
    if (this.dataset.initialized === 'true') return;

    this.dataset.initialized = 'true';
    this.addEventListener('click', (event) => {
      const button = event.target.closest('[data-media-index]');
      if (!button || !this.contains(button)) return;

      this.selectMedia(button.dataset.mediaIndex);
    });
  }

  selectMedia(index) {
    const panels = [...this.querySelectorAll('[data-media-panel]')];
    if (!panels.some((panel) => panel.dataset.mediaPanel === index)) return;

    for (const button of this.querySelectorAll('[data-media-index]')) {
      button.setAttribute('aria-selected', String(button.dataset.mediaIndex === index));
    }

    for (const panel of panels) {
      panel.hidden = panel.dataset.mediaPanel !== index;
      if (panel.hidden) {
        for (const video of panel.querySelectorAll('video')) video.pause();
      }
    }
  }
}

if (!customElements.get('maker-is-product-media-fallback')) {
  customElements.define('maker-is-product-media-fallback', MakerIsProductMediaFallback);
}
